// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1NqDR","title":"FrontImage_title__1EP_p"};